import { render, staticRenderFns } from "./EmailAttachmentsList.vue?vue&type=template&id=47a1d30c&scoped=true&"
import script from "./EmailAttachmentsList.vue?vue&type=script&lang=ts&"
export * from "./EmailAttachmentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a1d30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardActions,VCol,VIcon})
